import React from 'react'

export interface ThProps
  extends React.HTMLAttributes<HTMLTableHeaderCellElement> {
  scope?: 'row' | 'col' | 'rowgroup' | 'colgroup'
}

const Th = React.forwardRef<HTMLTableHeaderCellElement, ThProps>(
  ({ children, scope = 'col' }, ref) => {
    return (
      <th
        ref={ref}
        scope={scope}
        className="px-2 py-4 overflow-hidden text-base font-normal tracking-wider text-center bg-secondary text-light-50 overflow-ellipsis whitespace-nowrap"
      >
        {children}
      </th>
    )
  }
)

export default Th
